import { render, staticRenderFns } from "./TableForm22.vue?vue&type=template&id=d593ae96&scoped=true"
import script from "./TableForm22.vue?vue&type=script&lang=ts"
export * from "./TableForm22.vue?vue&type=script&lang=ts"
import style0 from "./TableForm22.vue?vue&type=style&index=0&id=d593ae96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d593ae96",
  null
  
)

export default component.exports